// Function to get initials of first & last name
export function getInitials(string){
    if (string === undefined) {
        return "";
    }
    // Replace all special characters from string
    var stringClean = string.replace(/[^\w\s]/gi, '')
    
    var names = stringClean.split(' '),
        initials = names[0].substring(0, 1).toUpperCase();

    if (names.length > 1) {
        initials += names[names.length - 1].substring(0, 1).toUpperCase();
    }
    return initials;
};